import {Button, Divider} from "antd";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../utilis/contexts/AuthContext";
import {Form, Input} from "antd"
import {useNavigate} from "react-router-dom";
import {GetWorkFlowValidation, Validation, WasteWaterBranchAssignmentValidation} from "../utilis/tools/validation";


const FindWorkFlow = () => {
    const navigate=useNavigate();
    const authContext = useContext(AuthContext)


    const handleWorkFlow=(values:any)=>{
        navigate('/panel/Workflow', { state: { TraceNumber: values.traceNumber, BillId:values.billId,Cellphone:authContext.user.cellphone } });
    }
    const onFinishFailed=(e:any)=>{
        console.log(e)
    }
    return <>
        <Divider><h3 className="font-bold ">پیگیری درخواست</h3></Divider>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleWorkFlow}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >
            <Form.Item
                label="شناسه قبض"
                name="billId"
                rules={[Validation(GetWorkFlowValidation)]}

            >
                <Input type="tel" size="large" placeholder="شناسه قبض را وارد کنید"/>
            </Form.Item>
            <Form.Item
                label="کد رهگیری"
                name="traceNumber"
                rules={[Validation(GetWorkFlowValidation)]}

            >
                <Input type="tel" size="large" placeholder="کد رهگیری را وارد کنید"/>
            </Form.Item>
            <Form.Item className="w-full mt-4">
                <Button   size="large" type="primary"
                        className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    پیگیری درخواست
                </Button>
            </Form.Item>
        </Form>

    </>
}
export default FindWorkFlow;